import { BadgePercent, ArrowUpRight, Handshake } from "lucide-react";
import { LOVABLE_URL, EMERGENT_URL, scrollToId } from "./shared";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="relative border-t border-white/[0.07] bg-[#040404]">
      <div className="mx-auto max-w-7xl px-4 py-8 sm:px-6 md:py-10 lg:px-8">
        <div className="flex flex-col items-start justify-between gap-8 md:flex-row md:items-center md:gap-10">
          <div>
            <div className="flex items-center gap-2.5">
              <span className="flex h-8 w-8 items-center justify-center rounded-lg border border-cyan-400/30 bg-cyan-400/10">
                <BadgePercent className="h-4 w-4 text-cyan-300" />
              </span>
              <span className="font-display text-base font-bold text-white">
                Grab<span className="text-gradient-cyan">Perks</span>
              </span>
            </div>
            <p className="mt-3 max-w-md text-sm leading-relaxed text-slate-500 md:mt-4">
              Independent, hands-on reviews of AI builders. We build with every tool before we
              score it.
            </p>
          </div>
          <div className="flex w-full flex-row items-start justify-between gap-6 md:w-auto md:flex-col md:gap-3">
            <div className="flex flex-col gap-3">
              <a
                data-testid="footer-lovable-link"
                href={LOVABLE_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="group flex items-center gap-2 text-sm text-slate-400 transition-colors duration-300 hover:text-white"
              >
                lovable.dev
                <ArrowUpRight className="h-3.5 w-3.5 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
              </a>
              <a
                data-testid="footer-emergent-link"
                href={EMERGENT_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="group flex items-center gap-2 text-sm text-slate-400 transition-colors duration-300 hover:text-white"
              >
                emergent.sh
                <ArrowUpRight className="h-3.5 w-3.5 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
              </a>
            </div>
            <button
              data-testid="footer-back-to-top-btn"
              onClick={() => scrollToId("#top")}
              className="pt-0.5 text-right font-mono2 text-[11px] uppercase tracking-[0.25em] text-slate-600 transition-colors duration-300 hover:text-cyan-300 md:mt-2 md:pt-0 md:text-left"
            >
              Back to top ↑
            </button>
          </div>
        </div>
        <div
          data-testid="affiliate-disclosure"
          className="mt-8 hidden rounded-2xl border border-white/10 bg-white/[0.03] p-5 backdrop-blur-sm md:block"
        >
          <div className="flex items-start gap-3">
            <Handshake className="mt-0.5 h-4 w-4 shrink-0 text-cyan-300" />
            <p className="text-xs leading-relaxed text-slate-500">
              <span className="font-semibold text-slate-300">Affiliate Disclosure:</span>{" "}
              GrabPerks is an independent review and recommendation platform. We may earn a
              commission when users sign up through links on this page at no additional cost to
              them.
            </p>
          </div>
        </div>
        <div className="mt-5 flex flex-col gap-2 border-t border-white/[0.06] pt-4 text-xs text-slate-600 md:mt-6 md:flex-row md:items-center md:justify-between md:pt-5">
          <p>© 2026 GrabPerks. All rights reserved.</p>
          <p>Product names and trademarks belong to their respective owners.</p>
        </div>
      </div>
    </footer>
  );
}
